"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShimmerBase = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.ShimmerBase = (0, styled_1.default)(`div`) `
  border-radius: 2px;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 10%,
    ${(0, ui_theme_1.fromTheme)('color_background_disabled_form_input')} 18%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  height: 100%;
  position: relative;
`;
//# sourceMappingURL=styles.js.map